<template>
  <div
    class="otb-text-carousel"
    :class="`otb-text-carousel-${variant}`"
    v-touch:swipe.right="swipeHelperLeft"
    v-touch:swipe.left="swipeHelperRight"
  >
    <button
      class="wb-round-button wb-round-button--small rtl-flip-h"
      :disabled="!leftArrowActive"
      role="navigation"
      @click="choose('prev')"
      v-if="options.length > 1"
    >
      <wb-icon
        class="wb-round-button__icon"
        aria-hidden="true"
        flip-rtl
        name="chevron-left"
      ></wb-icon>
    </button>
    <div>
      <label v-if="label" class="otb-text-carousel-label wb-type-heading-xs">{{
        label
      }}</label>
      <ul class="otb-text-carousel-list">
        <li
          v-for="(option, index) in options"
          class="otb-text-carousel-option wb-type-heading-xs"
          :class="[activeClass(index, option)]"
          :key="index"
          ref="options"
        >
          {{ option }}
        </li>
      </ul>
    </div>
    <button
      class="wb-round-button wb-round-button--small rtl-flip-h"
      :disabled="!rightArrowActive"
      role="navigation"
      @click="choose('next')"
      v-if="options.length > 1"
    >
      <wb-icon
        class="wb-round-button__icon"
        aria-hidden="true"
        flip-rtl
        name="chevron-right"
      ></wb-icon>
    </button>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

import useTextCarousel from '../../composables/text-carousel.composable';

export default defineComponent({
  name: 'otb-text-carousel',
  components: {},
  props: {
    activeSlide: {
      type: Number,
      default: 0,
    },
    infinite: {
      type: Boolean,
    },
    label: {
      type: Array as () => string[],
    },
    numberOfSlides: {
      type: Number,
    },
    options: {
      type: Array as () => string[],
      default() {
        return [];
      },
    },
    value: {
      type: String,
    },
    variant: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const TextCarousel = useTextCarousel(props, { emit });

    return {
      ...TextCarousel,
    };
  },
});
</script>
<style src="./text-carousel.scss" lang="scss"></style>
